import { Box, Tooltip } from '@mui/material';

import type { TaskCar } from '~/data/generated/model';

const SHOWN = 2;

export function elevatorSummary(cars: readonly TaskCar[], emptyLabel = 'Property-wide'): string {
  if (cars.length === 0) return emptyLabel;
  const names = cars.slice(0, SHOWN).map((car) => car.name);
  const rest = cars.length - SHOWN;
  return rest > 0 ? `${names.join(', ')} +${rest}` : names.join(', ');
}

export function ElevatorNames({
  cars,
  emptyLabel = 'Property-wide',
}: {
  cars: readonly TaskCar[];
  emptyLabel?: string;
}) {
  const label = elevatorSummary(cars, emptyLabel);
  const text = (
    <Box
      component="span"
      sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: 0 }}
    >
      {label}
    </Box>
  );
  if (cars.length <= SHOWN) return text;
  return <Tooltip title={cars.map((car) => car.name).join(', ')}>{text}</Tooltip>;
}
